export default __webpack_public_path__ + "static/media/doctor-3.1a4fbcd0.jpg";